// @sentry-internal/replay · replay-canvas · feedback 를 대체하는 noop stub.
//
// 이 앱은 Session Replay / User Feedback 을 사용하지 않는다(sentry.client.config 의 init 에
// 미등록 + @sentry/browser 기본통합에도 미포함). 그러나 @sentry/nextjs → @sentry/react 재수출
// 체인 탓에 트리셰이킹이 되지 않아 실제 코드(replay 258KB + feedback 79KB, gzip ~118KB)가
// 클라이언트 번들에 상시 잔존한다.
//
// next.config.js 의 NormalModuleReplacementPlugin 이 해당 모듈들을 이 파일로 치환해 실제 코드를
// 번들에서 제거한다. 미사용이라 런타임에 접근될 일은 없지만, 재수출 평가/방어적 접근에서 throw 가
// 나지 않도록 어떤 export 에 접근하더라도 noop integration 팩토리를 돌려준다.
const noopIntegration = () => ({
  name: 'Noop',
  setupOnce() {},
  setup() {},
});

module.exports = new Proxy(
  { __esModule: true },
  {
    get(target, prop) {
      if (prop in target) return target[prop];
      return noopIntegration;
    },
  },
);
